<template lang="pug">
  #app.clearfix
    navbar.clearfix.navbar.navbar-default(
      v-if="authed && $route.path !== '/login'"
      placement='top'
      type='default')
      a.navbar-brand(slot='brand' v-link="{name: 'index'}")
        span(style="color:#c22") Intri
        span Notify
      li
        a(v-link="{path: '/'}")
          i.glyphicon.glyphicon-dashboard
          |  Dashboard
      li
        a(v-link="{path: '/servicelog'}")
          i.glyphicon.glyphicon-list-alt
          |  Notification Log
      li(slot="right")
        span.btn-group.currency_area
          span.currency_label Currency
          v-select.currency_list(
            v-bind:value.sync="selectedCurrency"
            @change="updateSelectedCurrency"
            search
          )
            v-option(v-for="option in currencyOptions" v-bind:value="option.name")
              img.flag_size(:src="option.icon")
              | {{ option.name }}
      dropdown(v-bind:text='user.email' slot='right')
        li
          a(@click="logout")
            i.fa.fa-sign-out
            | &nbsp;Logout
        li
          a Ver. {{ version }}
    .main
      router-view
    alert(
      v-bind:type="alertData.type"
      v-bind:show.sync="alertData.show"
      v-bind:duration="1000"
      width="280px"
      placement="top-right"
      dismissable)
      span.icon-ok-circled.alert-icon-float-left
      strong {{ alertData.title }}
      p {{ alertData.content }}
</template>

<script>
import _ from 'lodash'
import { navbar, dropdown, alert, select, option } from 'vue-strap'
import { firebaseLogout, AUTH_STATE_AUTHED, store } from './index'
import { version } from '../package.json'
import country2currency from '../static/currency.json'
import currencySigniture from '../static/currencymap.json'

export default {
  components: {
    navbar,
    dropdown,
    alert,
    'v-select': select,
    'v-option': option
  },
  data: () => ({
    version,
    alertList: [],
    alertData: {
      type: '',
      title: '',
      show: false,
      content: ''
    }
  }),
  vuex: {
    getters: {
      user: state => state.user,
      authed: state => state.authState === AUTH_STATE_AUTHED,
      foreignExchangeRate: state => state.foreignExchangePrice.rates,
      defaultCurrency: state => state.selectedCurrency.code
    }
  },
  computed: {
    selectedCurrency () {
      return this.defaultCurrency
    },
    currencyOptions () {
      const currencyTypes = _.keys(this.foreignExchangeRate)
      const currency2country = _.invert(country2currency)
      const options = _.transform(currencyTypes, (result, currency, index) => {
        if (currency2country[currency] == null) return
        const lowerCode = currency2country[currency].toLowerCase()
        result.push({
          icon: `https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/2.9.0/flags/4x3/${lowerCode}.svg`,
          name: currency
        })
      }, [])
      // console.table(_.sortBy(options, 'name'))
      return _.sortBy(options, 'name')
    }
  },
  methods: {
    logout () {
      firebaseLogout().then(() => {
        // this.alert('success', '', 'Logout Success')
        this.$router.replace('/login')
      })
    },
    alert ({type, title, content}) {
      console.log(type)
      console.log(title)
      console.log(content)
      let newAlert = {
        type,
        title,
        content,
        show: true
      }
      this.alertList.push(newAlert)
    },
    updateSelectedCurrency (newCurr) {
      store.dispatch('selectNewCurrency', currencySigniture[newCurr])
    }
  },
  events: {
    alert (e) {
      console.log(e)
      this.alert(e)
    }
  },
  ready () {
    setInterval(() => {  // make alerts wait in list
      if (this.alertList.length) {
        this.alertData = this.alertList.shift()
        this.alertData.show = false
        setTimeout(() => {
          this.alertData.show = true
        }, 1500)
      }
    }, 2000)
  }
}
</script>

<style lang='scss'>
@import './scss/w3.css';
@import './scss/main.scss';
@import "~font-awesome/css/font-awesome.min.css";

html {
  height: 100%;
}

body {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

#app {
  width: 100vw;
  height:  100vh;
}
.main {
  margin-top: 40px;
}
.flag_size {
  position: relative;
  top: -1.6px;
  padding-right: 3px;
  height: 15px;
  width: 20px;
}

.currency_area {
  position: relative;
  top: 8px;
  border: solid 1px #ccc;
  border-radius: 4px;
  margin-right: 10px;
  .currency_label {
    padding: 0 10px;
    // margin-right: 5px;
  }
  .currency_list {
    display: inline-block;
    button {
      border: none;
      border-radius: 0 4px 4px 0;
      border-left: solid 1px #ccc;
      // background-color: #aaa;
    }
  }
  /* overwrite select height */
  .dropdown-menu {
    height: 400px;
    overflow-y: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?7cfebc80